/**
 * Changes the body attribute
 */
const changeHTMLAttribute = (attribute: any, value: string) => {
  if (document.documentElement) document.documentElement.setAttribute(attribute, value);
  return true;
};

/**
 * Aplica tema inicial do localStorage
 */
const applyInitialTheme = () => {
  try {
    const savedTheme = localStorage.getItem("app-theme");
    const theme = savedTheme === "dark" ? "dark" : "light";

    changeHTMLAttribute("data-mode", theme);

    if (theme === "dark") {
      changeHTMLAttribute("data-sidebar", "dark");
      changeHTMLAttribute("data-topbar", "dark");
    } else {
      changeHTMLAttribute("data-sidebar", "light");
      changeHTMLAttribute("data-topbar", "light");
    }
    return theme;
  } catch (error) {
    console.warn("Erro ao aplicar tema inicial:", error);
    return "light";
  }
};

export { applyInitialTheme, changeHTMLAttribute };
